import { useEffect, useState } from "react";

export default function Countdown({ targetDate, label, compact = false, testid = "countdown" }) {
  const [now, setNow] = useState(new Date());

  useEffect(() => {
    const t = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(t);
  }, []);

  const target = targetDate instanceof Date ? targetDate : new Date(targetDate);
  const diff = Math.max(0, target.getTime() - now.getTime());
  const d = Math.floor(diff / (1000 * 60 * 60 * 24));
  const h = Math.floor((diff / (1000 * 60 * 60)) % 24);
  const m = Math.floor((diff / (1000 * 60)) % 60);
  const s = Math.floor((diff / 1000) % 60);

  const expired = diff === 0;

  if (compact) {
    return (
      <div data-testid={testid} className="inline-flex items-baseline gap-2 font-[Outfit] text-emerald-50">
        {label && <span className="text-xs uppercase tracking-[0.2em] opacity-80">{label}</span>}
        <span className="font-medium">{d}d {h}h {m}m {s}s</span>
      </div>
    );
  }

  return (
    <div data-testid={testid} className="flex flex-col gap-2">
      {label && (
        <span className="text-[11px] uppercase tracking-[0.25em] text-emerald-200/90">
          {label}
        </span>
      )}
      {expired ? (
        <div className="text-3xl font-[Cormorant_Garamond] text-rose-200">Time's up.</div>
      ) : (
        <div className="grid grid-cols-4 gap-3 max-w-md">
          {[
            ["Days", d],
            ["Hours", h],
            ["Min", m],
            ["Sec", s],
          ].map(([k, v]) => (
            <div key={k} className="bg-emerald-800 border border-emerald-700 rounded-lg px-3 py-3 text-center">
              <div className="font-[Cormorant_Garamond] text-3xl sm:text-4xl text-white leading-none tabular-nums">
                {String(v).padStart(2, "0")}
              </div>
              <div className="text-[10px] uppercase tracking-[0.2em] text-emerald-100/70 mt-1">{k}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
